import {useState} from "react";
import {AddressData} from "../types/AddressData";
import axios from "axios";

export const useAddressService = () => {
    const [addressData, setAddressData] = useState<AddressData>();
    const [loading, setLoading] = useState(false);

    const fetch = async(zipcode: string) => {
        setLoading(true)
        await axios.get(`${process.env.REACT_APP_ADDRESS_SERVICE_URL}/v1/address/zipcode/${zipcode}`).then(res => {
            setAddressData(res.data)
        }).catch(() =>{
            setAddressData(undefined)
        }).finally(() =>setLoading(false))

    }

    return {
        fetch,
        loading,
        addressData
    }
}